var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSedanSpeedometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 221,
    viewBox: "0 0 535 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.594 16.8945C179.397 5.51763 176.667 5.51754 153.458 5.51758C128.883 5.51762 115.686 11.8887 97.9381 21.9004C73.5155 37.0697 23.4873 69.2285 18.7545 76.5098C12.8385 85.6113 -0.81389 92.4375 2.82674 123.383C5.73924 148.139 11.9283 178.296 14.6587 190.279C16.6307 196.347 24.6705 209.029 41.0533 211.213C57.4361 213.397 84.2857 216.674 95.6626 218.039C102.944 218.798 121.602 216.674 129.794 212.123L187.133 190.734",
    stroke: "#FFFF00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.128 11.4336C352.326 0.0566997 358.697 2.78721 381.906 2.78724C406.48 2.78728 418.767 10.5235 436.515 20.5352C460.938 35.7045 510.966 67.8633 515.699 75.1446C521.615 84.2461 535.267 91.0723 531.626 122.018C528.714 146.774 522.525 176.93 519.794 188.914C517.822 194.982 509.783 207.663 493.4 209.848C477.017 212.032 450.167 215.309 438.79 216.674C431.509 217.432 412.851 215.309 404.66 210.758L347.32 189.369",
    stroke: "#FFFF00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.959 17.3496L338.674 12.3438M187.133 190.734L347.775 189.369",
    stroke: "#FFFF00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 213.617,
    y: 41.5586,
    width: 100.848,
    height: 128.152,
    stroke: "#FFFF00",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanSpeedometer);
export default __webpack_public_path__ + "static/media/sedan-speedometer.be5de5baf800ce56387d178382b471e1.svg";
export { ForwardRef as ReactComponent };